import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import "react-toastify/dist/ReactToastify.css";
import "../mapping/csvListUploadForm.css";
import _ from "lodash";
import { Col, Row } from "react-bootstrap";
import { Button } from "bootstrap-4-react/lib/components";
import React, { useState, useEffect } from "react";
import Trash from "../../assets/trashRed.svg";
import { toast } from "react-toastify";
import {
  ProductListFileUpload,
  getAllMarketPlaces,
  getMarketplacesIntegrations,
  getProductListTemplateUrl,
  outboundBulkUpload,
  outboundBulkUploadSampleTemplate,
  uploadReturnMarketplaceFile,
} from "../../store/actions/inventory.action";
import { useDispatch, useSelector } from "react-redux";
import LoaderSpinner from "./Loader";
import { getSelectList } from "../../config/utils";
import PropTypes from "prop-types";

export function BulkUploadDialog(props) {
  const [fileName, setFileName] = useState("");
  const [File, setFile] = useState();
  const [errors, setErrors] = useState({});
  const createdBy = useSelector((state) => state?.auth?.user);
  const { allMarketPlaces } = useSelector((state) => state?.InventoryManagement);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    Name: "",
    CarrierId: "",
    BaseMasterId: 0,
  });

  const [loader, setLoader] = useState(false);
  const [sampleTemplateUrl, setSampleTemplateUrl] = useState("");

  useEffect(() => {
    if (formData?.marketplace?.value) {
      getIntegrations(formData.marketplace.value);
    }
  }, [formData.marketplace]);


  const getIntegrations = (marketplaceId) => {
    getMarketplacesIntegrations(marketplaceId).then((res) => {
      let createList = getSelectList([...(res?.data?.EntityList || [])], 'id', 'name');
      if (res.data.Status === 200) {
        setFormData({
          ...formData,
          marketplaceIntegration: createList,
          Integration: []
        });
      } else {
        toast.error(res.data?.Entity.message);
      }
    }).catch((err) => {
      console.error(err);
    });
  }

  useEffect(() => {
    if (props.type === 2) {
      downloadTemplate();
    }
    if (props.type === 3) {
      // For bulk upload, returns management
      dispatch(getAllMarketPlaces())
    }
  }, [props.type]);

  const downloadTemplate = async () => {
    setLoader(true);
    try {
      const res = await outboundBulkUploadSampleTemplate();
      setSampleTemplateUrl(res.data.Entity);
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  const validateReturnUploadForm = () => {
    let isValid = true;
    let errorsObj = {};
    if (!formData?.marketplace?.value) {
      isValid = false;
      errorsObj.marketplace = "Required field";
    }
    if (!formData?.Integration?.value) {
      isValid = false;
      errorsObj.Integration = "Required field";
    }
    if (!fileName) {
      isValid = false;
      errorsObj.chooseFile = "Choose file";
    }
    setErrors(errorsObj);
    return isValid;
  }

  const validateForm = () => {
    let isValid = true;
    let errorsObj = {};
    if (!formData.Id) {
      isValid = false;
      errorsObj.Id = "Required field";
    }
    if (!fileName) {
      isValid = false;
      errorsObj.chooseFile = "Choose file";
    }
    setErrors(errorsObj);
    return isValid;
  };

  const handleSelectChange = (item, field) => {
    setFormData({
      ...formData,
      [field]: item,
    });
    setErrors({
      ...errors,
      [field]: "",
    });
  };

  const handleCsvForm = (item) => {
    setFormData({
      Name: item.label,
      IntegrationId: item?.value,
      Id: item?.value,
      CreatedBy: createdBy,
      csvTemp: item,
    });
    setErrors({
      ...errors,
      Id: "",
    });
  };

  const handleCancelUpload = () => {
    props.onHide();
  };

  const handleUploadClick = async (event) => {
    const fileNamechosen = event.target.files[0].name;
    setFile(event.target.files[0]);
    setFileName(fileNamechosen);
    setErrors({
      ...errors,
      chooseFile: "",
    });
  };

  const onTrashClick = () => {
    setFileName(null);
  };

  const handleUploadFile = async () => {
    if (validateForm()) {
      setLoader(true);
      const fd = new FormData();
      fd.append("FormFile", File);
      fd.append("IntegrationId", formData?.IntegrationId);
      fd.append("CreatedBy", createdBy?.Value?.employeeId);
      fd.append("SellerId", createdBy?.Value?.sellerId);
      fd.append("CompanyId", createdBy?.Value?.companyId);
      fd.append("CompanySellerId", createdBy?.Value?.companySellerId);
      fd.append("Role", createdBy?.Value?.role);
      fd.append("ModifiedBy", createdBy?.Value?.employeeId);
      setErrors({
        ...errors,
        chooseFile: "",
      });

      let resp = await Promise.resolve(dispatch(ProductListFileUpload(fd)));
      if (resp.data.Entity.errorFileUrl === "") {
        if (resp.data.Status === 200) {
          toast.success(resp.data?.Entity.message);
          props.onHide();
          props?.fetchProductList();
        } else {
          toast.error(resp.data?.Entity.message);
          setFileName("");
          setFormData({ ...formData, csvTemp: "", Id: "" });
        }
      } else if (resp.data.Status === 200) {
          const link = document.createElement("a");
          link.href = resp.data.Entity.errorFileUrl;
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          toast.success(resp.data?.Entity.message);
          props.onHide();
          props?.fetchProductList();

        } else {
          const link = document.createElement("a");
          link.href = resp.data.Entity.errorFileUrl;
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          toast.error(resp.data?.Entity.message);
          setFileName("");
          setFormData({ ...formData, csvTemp: "", Id: "" });
        }
      setLoader(false);
    }
  };

  useEffect(() => {
    if (!_.isEmpty(formData.csvTemp)) {
      fetchSampleTemplateUrl(formData.csvTemp);
    }
  }, [formData.csvTemp]);

  const fetchSampleTemplateUrl = async (integrationObj) => {
    let data = `integrationId=${integrationObj.value}&integrationName=${integrationObj.label}`;
    let response = await Promise.resolve(
      dispatch(getProductListTemplateUrl(data))
    );
    if (response?.data?.Status === 200) {
      setSampleTemplateUrl(response?.data?.Entity);
    }
  };

  const handleReturnUpload = async (e) => {
    if (validateReturnUploadForm()) {
      setLoader(true);
      const fd = new FormData();
      fd.append("FormFile", File);
      fd.append("MarketplaceName", formData?.marketplace?.label);
      fd.append("IntegrationId", formData?.Integration?.value);
      fd.append("CreatedBy", createdBy?.Value?.employeeId);
      fd.append("SellerId", createdBy?.Value?.sellerId);
      fd.append("CompanyId", createdBy?.Value?.companyId);
      fd.append("CompanySellerId", createdBy?.Value?.companySellerId);
      fd.append("Role", createdBy?.Value?.role);
      fd.append("ModifiedBy", createdBy?.Value?.employeeId);
      setErrors({
        ...errors,
        chooseFile: "",
      });
      let resp = await uploadReturnMarketplaceFile(fd);
      if (resp.data.Status === 200) {
        toast.success(resp.data?.Entity.message);
        props.onHide();
        props.fetchProductList?.();
      } else {
        setLoader(false);
        toast.error(resp.data?.Entity.message);
        setFileName("");
        setFormData({ ...formData, csvTemp: "", Id: "" });
      }
      setLoader(false);
    }
  }

  const handleUploadCsv = async (e) => {
    const outboundCSVFile = new FormData();
    outboundCSVFile.append("File", File);
    setLoader(true);
    let resp = await Promise.resolve(dispatch(outboundBulkUpload(outboundCSVFile)));
    setLoader(false);
    if (resp.data.HasError) {
      toast.error(resp.data.Error);
      resp.data.ErrorFilePath && window.open(resp.data.ErrorFilePath);
    } else {
      toast.success('File uploaded successfully');
      props?.renderData(e, 'clear');
      handleCancelUpload();
    }
  };

  const getUploadHandler = () => {
    if (props.type === 2) return handleUploadCsv;
    if (props.type === 3) return handleReturnUpload;
    return handleUploadFile;
  };


  return (
    <div>
      <Modal {...props} className="modalDeleteWrapper" size="lg">
        <Modal.Header closeButton>
          <div className="modal-main-div">
            {loader ? (
              <>
                <text className="modal-m-text"> Upload CSV</text>{" "}
                <LoaderSpinner />
              </>
            ) : (
              <text className="modal-m-text"> Upload CSV</text>
            )}
          </div>
        </Modal.Header>
        <Modal.Body className="selectSvcModal fontFix">
          {!props.hideIntegration && (
            <div className="row modal_input">
              <div className="col-4 formLabel csv_label alignRight">Select CSV Template</div>
              <div className="col-8">
                <div className={"select_react_Csv"}>
                  <Select
                    options={
                      props?.gridData?.map((data) => {
                        return {
                          label: data.name,
                          value: data.id,
                        };
                      })
                    }
                    onChange={(value) => handleCsvForm(value)}
                    value={formData?.csvTemp}
                    placeholder="Select template.."
                    classNamePrefix={'list'}
                  />
                  <p className="error dialogError">{errors.Id}</p>
                </div>
              </div>
            </div>
          )}
          {props.type === 3 && (
            <>
              <div className="row modal_input">
                <div className="col-4 formLabel csv_label alignRight">Select Marketplace</div>
                <div className="col-8">
                  <div className={"select_react_Csv"}>
                    <Select
                      options={allMarketPlaces}
                      onChange={(value) => handleSelectChange(value, 'marketplace')}
                      value={formData?.marketplace}
                      placeholder="Select..."
                      classNamePrefix={'list'}
                    />
                    <p className="error dialogError">{errors.Id}</p>
                  </div>
                </div>
              </div>
              <div className="row modal_input">
                <div className="col-4 formLabel csv_label alignRight">Select Integration</div>
                <div className="col-8">
                  <div className={"select_react_Csv"}>
                    <Select
                      options={formData?.marketplaceIntegration}
                      isDisabled={!formData?.marketplace}
                      onChange={(value) => handleSelectChange(value, 'Integration')}
                      value={formData?.Integration}
                      placeholder="Select..."
                      classNamePrefix={'list'}
                    />
                    <p className="error dialogError">{errors.Id}</p>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="row modal_input">
            <div className="col-4"></div>
            <div className="col-8">
              <div className="bulkUpload_box mt-4">
                <div>
                  {fileName ? (
                    <div>
                      {fileName}
                      <span className="trash-icon">
                        {" "}
                        <button
                        type="button"
                        className="trash-Btn sortBtn"
                        onClick={onTrashClick}
                        aria-label="Delete"
                      >
                        <img src={Trash} alt="" className="trash-Img" />
                      </button>
                      </span>
                    </div>
                  ) : (
                    <>
                      <button className="btn-input-csv">
                        <label className="btn-chooseFile" htmlFor={`actual-btn-6`}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-upload"
                            viewBox="0 0 16 16"
                            cursor="pointer"
                          >
                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                            <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                          </svg>&nbsp; Choose File{" "}
                        </label>
                      </button>
                      <input
                        type="file"
                        name="file"
                        accept=".csv"
                        id={`actual-btn-6`}
                        onChange={(e) => {
                          handleUploadClick(e);
                        }}
                        hidden
                      />
                    </>
                  )}
                  <p className="error file-upload">{errors.chooseFile}</p>
                  {sampleTemplateUrl && (
                    <div>
                      <a rel="noreferrer" href={sampleTemplateUrl} target="_blank">
                        Download Sample Template
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Row className="modaL_footer">
            <Col xs={6}></Col>
            <Col className="csv_Buttons" xs={6}>
              <Button
                className="btn cus-seconday-bg-btn uploadBtn"
                onClick={getUploadHandler()}
                disabled={loader || !File}
              >
                Upload
              </Button>
              <Button
                className="btn cus-seconday-bg-btn marginLeft5"
                onClick={() => handleCancelUpload()}
                disabled={loader}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
}

BulkUploadDialog.propTypes = {
  onHide: PropTypes.func.isRequired,
  type: PropTypes.number.isRequired,
  hideIntegration: PropTypes.bool,
  fetchProductList: PropTypes.func,
  gridData: PropTypes.array.isRequired,
  renderData: PropTypes.func
};